export const resolveLang = (lng) => {
  const l = (lng || "").toLowerCase();
  if (l.startsWith("de")) return "DE";
  if (l.startsWith("fr")) return "FR";
  if (l.startsWith("it")) return "IT";
  if (l.startsWith("en")) return "EN";
  return "DE";
};

export const VIDEO_BY_LANG = {
  DE: {
    src: "https://www.youtube.com/watch?v=uBloysRQ2Jw",
    image: "/images/video.png",
  },
  FR: {
    src: "https://www.youtube.com/watch?v=NhiJ4skptRQ",
    image: "/images/video.png",
  },
  IT: {
    src: "https://www.youtube.com/watch?v=InMqMhvM65s",
    image: "/images/video.png",
  },
  EN: {
    src: "https://www.youtube.com/watch?v=SYBXB3q82XU",
    image: "/images/video.png",
  },
};
